const template = `#!/bin/bash

adb wait-for-device
sleep 3
adb root
sleep 3
adb remount
sleep 3
adb reboot

sleep 10

adb wait-for-device
sleep 3
adb root
sleep 3
adb remount
adb push <key> /data/vendor/wisa/wisalicensekey.txt
`;

/**
 * Download script to download license
 * @param licenseHash license hash
 */
export const downloadCustomerScript = (fileName: string, licenseHash: string, vendorId: string) => {
  const keyFileName = `${vendorId}_${fileName}.key`;

  // Download .key file containing licenseHash
  const keyBlob = new Blob([licenseHash], { type: "text/plain" });
  const keyUrl = URL.createObjectURL(keyBlob);
  const keyAnchor = document.createElement("a");
  keyAnchor.href = keyUrl;
  keyAnchor.download = keyFileName;
  document.body.appendChild(keyAnchor);
  keyAnchor.click();
  document.body.removeChild(keyAnchor);
  URL.revokeObjectURL(keyUrl);

  const script = template.replace("<key>", keyFileName);

  // Download as .sh file
  const blob = new Blob([script], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName + ".sh";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
